import React from "react";

import { TFunction } from "utils";

import { CurrencyCode } from "consts";

import { FarmPaymentsResponse, Module } from "models";

import { PayoutImpactCard } from "components";

type PastPaymentsType = {
  farmPayments: FarmPaymentsResponse | undefined;
  t: TFunction;
  payoutYear: number;
  modules: Module[];
  currency?: CurrencyCode;
};

export const PastPayments = ({ farmPayments, t, payoutYear, modules, currency }: PastPaymentsType) => (
  <div className="row-margin-top">
    <h2 className="margin-bottom-200">{t("paymentsHeadline")}</h2>
    {farmPayments?.referralPayments?.map((payment) => {
      // Only the referrals that have been paid (as they could be also "pending" but we decided to only show the paid)
      if (payment.status === "paid") {
        return (
          <PayoutImpactCard
            payout={payment.amount}
            currency={currency}
            invoiceDate={payment.date}
            deductedPayout={undefined}
            icons={[{ icon: "tabler/user" } as Module]}
            variant={"referral"}
            className="margin-bottom-100"
            unsigned={true}
            key={`${payment.date}`}
            dataTestId="wallet-payout-impact-card-invoice-referral"
          />
        );
      }
      return null;
    })}

    {farmPayments?.payments?.map((payment) => {
      if (payment.status === "paid" && payment.year <= payoutYear) {
        // Invoices
        return (
          <PayoutImpactCard
            payout={payment.amount}
            deductedPayout={payment.deductedAmount}
            currency={currency}
            invoiceDate={payment.date ?? undefined}
            icons={payment.type === "methods" ? ([{ icon: "tabler/wallet" }] as Module[]) : modules.filter((module) => payment.moduleIds.includes(module.id))}
            variant={"invoice"}
            year={payment.year}
            className="margin-bottom-100"
            unsigned={true}
            key={`${payment.year}-${payment.paymentId}`}
            dataTestId="wallet-payout-impact-card-invoice"
          />
        );
      }
      return null;
    })}
  </div>
);
